import React from 'react';
import { styles } from './styles';

export const OrgAndTimer = (props) => {
  const {
    event: {
      isPublishedAthlinks,
    },
    fetching,
    t
  } = props;

  if (fetching) {
    return (
      <div>
        <div style={styles.loadingTitle}/>
        <div style={styles.loadingDetail}/>
      </div>
    );
  } else if (isPublishedAthlinks) {
    const hasOrganization = !!(props.event.organization && props.event.organization.name);
    const hasTimer = !!(props.event.timer && props.event.timer.name);

    return (
      <div>
        { // Organization
          hasOrganization && getInfo(
            props.event.organization.name,
            props.event.organization.url,
            t('Organizer')
          )
        }

        { // Timer
          hasTimer && getInfo(
            props.event.timer.name,
            props.event.timer.url,
            t('Timer')
          )
        }
      </div>
    );
  } else {
    return null;
  }
};


function getInfo(name, url, title) {
  if (name) {
    const nameEl = url ?
      <a target='_blank' rel="noopener noreferrer" href={url} style={styles.name(true)} className={'elp-org-and-timer-links'}>
        {name}
      </a>
      :
      <p itemProp='name' style={styles.name(false)} className={'elp-org-and-timer-links'}>
        {name}
      </p>;

    return (
      <div itemScope itemProp='organizer' itemType='http://schema.org/Person' style={styles.container}>
        <div style={styles.eventTitle} className={'elp-org-and-timer-titles'}>
          {title}
        </div>
        {nameEl}
      </div>
    );
  }
}
